var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5349 2.41452C18.0707 1.96607 17.5195 1.61034 16.9128 1.36763C16.3061 1.12492 15.6558 1 14.9991 1C14.3424 1 13.6921 1.12492 13.0854 1.36763C12.4787 1.61034 11.9275 1.96607 11.4633 2.41452L10.4998 3.34476L9.53626 2.41452C8.5985 1.50912 7.32662 1.00047 6.00043 1.00047C4.67423 1.00047 3.40235 1.50912 2.46459 2.41452C1.52683 3.31992 1 4.5479 1 5.82833C1 7.10875 1.52683 8.33674 2.46459 9.24214L3.42808 10.1724L10.4998 17L17.5714 10.1724L18.5349 9.24214C18.9994 8.79391 19.3678 8.26171 19.6192 7.67596C19.8706 7.0902 20 6.46237 20 5.82833C20 5.19428 19.8706 4.56645 19.6192 3.9807C19.3678 3.39494 18.9994 2.86275 18.5349 2.41452V2.41452Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSvg);
export default __webpack_public_path__ + "static/media/heart-svg.71bc7bdf1f817873dcb69f4be52b99f7.svg";
export { ForwardRef as ReactComponent };